import React, { useEffect } from 'react';
import { FormSpy } from 'react-final-form';
import PropTypes from 'prop-types';

import GenericToggleButtonGroupField from '../../../commons/form-fields/GenericToggleButtonGroupField';
import ConsultantInvoiceBankPaymentSection from './ConsultantInvoiceBankPaymentSection';
import ConsultantInvoiceMailChequePaymentSection from './ConsultantInvoiceMailChequePaymentSection';
import { PAYMENT_MODE } from '../../InvoicingConstants';
import { getPaymentModeOptionsByCountry } from '../../../commons/CountryUtils';
import ConsultantInvoiceWireTransferSection from './ConsultantInvoiceWireTransferSection';

const ConsultantInvoicePayment = (props) => {
    const paymentModeOptions = getPaymentModeOptionsByCountry(
        props.consultantCountry
    );
    const paymentMode = props.values?.paymentMode;

    const _resetNonCurrentPaymentDetails = () => {
        if (paymentMode !== PAYMENT_MODE.MAIL_CHEQUE) {
            props.form.change('consultantInvoiceChequeDetails', {
                beneficiaryAddress: {
                    country:
                        props.values?.consultantInvoiceChequeDetails
                            ?.beneficiaryAddress?.country,
                },
            });
        }
        if (paymentMode !== PAYMENT_MODE.WIRE_TRANSFER) {
            props.form.change('consultantInvoiceWireTransferDetails', {
                beneficiaryAddress: {
                    country:
                        props.values?.consultantInvoiceWireTransferDetails
                            ?.beneficiaryAddress?.country,
                },
            });
        }
        if (paymentMode !== PAYMENT_MODE.BANK_PAYMENT) {
            props.form.change('consultantInvoiceBankDetails', {});
        }
    };

    useEffect(_resetNonCurrentPaymentDetails, [paymentMode]);

    const _renderPaymentDetailsInput = () => {
        switch (paymentMode) {
            case PAYMENT_MODE.BANK_PAYMENT:
                return (
                    <ConsultantInvoiceBankPaymentSection
                        consultantCountry={props.consultantCountry}
                    />
                );
            case PAYMENT_MODE.WIRE_TRANSFER:
                return (
                    <ConsultantInvoiceWireTransferSection
                        consultantCountry={props.consultantCountry}
                    />
                );
            case PAYMENT_MODE.MAIL_CHEQUE:
                return (
                    <ConsultantInvoiceMailChequePaymentSection
                        consultantCountry={props.consultantCountry}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <h2 className="text-center text-blue-700 font-semibold text-xl">
                Payment Section
            </h2>

            <div className="md:flex mt-8">
                <div className="mr-10">
                    <GenericToggleButtonGroupField
                        name="paymentMode"
                        options={paymentModeOptions}
                        inlineLabel={'Payment Mode'}
                        inlineLabelCss={
                            'text-gray-700 font-semibold mb-1 md:mb-0 md:text-left'
                        }
                        required
                    />
                </div>
            </div>

            {_renderPaymentDetailsInput()}
        </div>
    );
};

ConsultantInvoicePayment.propTypes = {
    consultantCountry: PropTypes.string,
    form: PropTypes.any,
    values: PropTypes.object,
};

const ConsultantInvoicePaymentSection = (props) => (
    <FormSpy {...props} component={ConsultantInvoicePayment} />
);

export default ConsultantInvoicePaymentSection;
